import React, { createContext, useContext } from 'react';
import createUploadService from '../upload.service';

const UploadServiceContext = createContext();

export const UploadServiceProvider = ({ children }) => {
  const uploadService = createUploadService();

  return (
    <UploadServiceContext.Provider value={uploadService}>
      {children}
    </UploadServiceContext.Provider>
  );
};

export const useUploadService = () => {
  const context = useContext(UploadServiceContext);
  if (context === undefined) {
    throw new Error('useUploadService must be used within an UploadServiceProvider');
  }
  return context;
};

export default UploadServiceContext;